import React, { useState, useEffect } from "react";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import Header from "../../../components/Header/Header";
import {
  Box,
  Card,
  Grid,
  ListItemText,
  Typography,
  TextField,
  Button,
  Tooltip,
  FormControl,
  Select,
  MenuItem,
  Switch,
  CircularProgress,
} from "@mui/material";
import CheckBox from "@mui/material/Checkbox";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import {
  getMergeProjectList,
  getMergeProjectBatches,
  clearMergeBatches,
  submitFinalOpFilesData,
  clearApiStatus,
  getMergedFiles,
  clearGetMergedFiles,
} from "../../../redux/administrator/actions";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import CalendarViewDayTwoToneIcon from "@mui/icons-material/CalendarViewDayTwoTone";
import "./mergeOpFiles.scss";
import ProgressBar from "../../../components/ProgressBar";
import { useNavigate } from "react-router-dom";
import AdminFooter from "../../../components/AdminFooter";
import { adminRoutes } from "../../../routes/routeConstants";
function Index() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const projectList = useSelector((state) => state?.admin?.mergeProjects);
  const batchList = useSelector((state) => state?.admin?.mergeBatches);
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const mergedFilesList = useSelector((state) => state?.admin?.mergedFiles);

  const [batchNames, setBatchNames] = useState([]);
  // const [finalBatches, setFinalBatches] = useState([]);
  const [data, setData] = useState([]);
  const [isDuplicte, setIsDuplidate] = useState(false);
  const [selectedProjectId, setSelectedProjIdToAddBatches] =
    React.useState(null);
  const [masterFileName, setMasterFileName] = useState("");
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [isMergedFilesApiCalled, setIsMergedFilesApiCalled] = useState(false);
  const [mergedFIlesList, setMergedFIlesList] = useState([]);
  const [batchSwitch, setBatchSwitch] = useState(false);
  const [batchLoader, setBatchLoader] = useState(false);
  const [filesLoader, setFilesLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    // get project list call
    dispatch(clearApiStatus());
    dispatch(clearMergeBatches());
    dispatch(getMergeProjectList());
    dispatch(clearGetMergedFiles());
    setBatchNames([]);
    // setFinalBatches([]);
    setIsMergedFilesApiCalled(false);
  }, [dispatch]);

  useEffect(() => {
    setBatchNames(batchList);
    setBatchLoader(false);
  }, [batchList]);

  useEffect(() => {
    if (mergedFilesList && mergedFilesList.length) {
      setMergedFIlesList(mergedFilesList);
      setIsMergedFilesApiCalled(true);
      setFilesLoader(false);
    }
  }, [mergedFilesList]);

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.apiSuccess === true) {
        if (apiStatus?.message === "Merged Successfully") {
          setLoader(false);
          setMessage(apiStatus?.message);
          setSuccess(true);
          setTimeout(() => {
            dispatch(clearApiStatus());
            dispatch(clearMergeBatches());
            dispatch(clearGetMergedFiles());
            setData([]);
            setSuccess(false);
            setMessage("");
            setBatchSwitch(false);

            setBatchNames([]);
            setIsMergedFilesApiCalled(false);
            setMergedFIlesList([]);
            setMasterFileName("");
            setSelectedProjIdToAddBatches(null);
            setErr(false);
            setFilesLoader(false);
            dispatch(getMergeProjectList());
            navigate(`/${adminRoutes.outputList}`);
          }, 1000);
        }
      } else if (apiStatus?.apiError === true && apiStatus?.next === false) {
        setMessage(apiStatus?.message);
        setErr(true);
        setFilesLoader(false);
        setLoader(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiStatus]);

  const handleProjectChecked = (e, project) => {
    const { value, checked } = e.target;

    if (checked) {
      setData([...data, { projName: project?.project_name, batches: [] }]);
    } else if (!checked) {
      setData((prev) => prev.filter((x) => x?.projName !== value));
    }
  };

  const getBatchesOfProject = (project) => {
    setBatchLoader(true);
    getBatchListOfSelectedProj(project?.project_name);
    // setFinalBatches([]);
  };

  const handleBatchChecked = (e, batch, batchIndex) => {
    const { checked } = e.target;
    if (checked) {
      batchNames[batchIndex].checked = true;
      setBatchNames([...batchNames]);
    } else if (!checked) {
      batchNames[batchIndex].checked = false;
      setBatchNames([...batchNames]);
    }
  };

  const getBatchListOfSelectedProj = (names) => {
    // get batch names for checked project
    let id = projectList.filter((index) => index.project_name === names);
    id = id[0].project_id;
    dispatch(getMergeProjectBatches(id));
    setBatchNames([]);
  };

  // const handleOpen = (i) => {
  //   data[i].isOpen = !data[i].isOpen;
  //   setData([...data]);
  // };

  const handleFocus = (i) => {
    data[i].isFocused = !data[i].isFocused;
    setData([...data]);
  };

  const addBatches = () => {
    let batchesToAdd;
    let filesToAAdd;

    if (batchNames?.length > 0) {
      batchesToAdd = batchNames.filter((batch) => batch.checked);
    }

    if (mergedFIlesList?.length > 0) {
      filesToAAdd = mergedFIlesList.filter((batch) => batch.checked);
    }

    if (
      selectedProjectId !== null &&
      selectedProjectId >= 0 &&
      (batchesToAdd?.length > 0 || filesToAAdd?.length > 0)
    ) {
      // let selectedBatches = data[selectedProjectId]?.batches;
      let selectedBatchNames = data[selectedProjectId]?.batches?.map(
        (batch) => batch.batch_name
      );

      if (batchesToAdd?.length > 0) {
        let mergedBatches = [
          ...data[selectedProjectId]?.batches,
          ...batchesToAdd.filter(
            (batch) => !selectedBatchNames.includes(batch.batch_name)
          ),
        ];
        const filteredMergedFiles = mergedBatches.filter(
          (batch) => batch.checked
        );

        data[selectedProjectId].batches = [...filteredMergedFiles];

        setData([...data]);
      }

      if (filesToAAdd?.length > 0) {
        let mergedBatches = [
          ...data[selectedProjectId]?.batches,
          ...filesToAAdd.filter(
            (batch) => !selectedBatchNames.includes(batch.batch_name)
          ),
        ];
        const filteredMergedFiles = mergedBatches.filter(
          (batch) => batch.checked
        );
        data[selectedProjectId].batches = [...filteredMergedFiles];
        setData([...data]);
      }
    } else if (
      selectedProjectId !== null &&
      selectedProjectId >= 0 &&
      (batchesToAdd?.length === 0 || filesToAAdd?.length === 0)
    ) {
      data[selectedProjectId].batches = [];
      setData([...data]);
    }
  };

  const handleChange = (event) => {
    setSelectedProjIdToAddBatches(event.target.value);
  };

  const handleProjectNameChange = (event, i) => {
    data[i].projName = event.target.value;
    setData([...data]);
  };

  const submit = () => {
    setLoader(true);
    dispatch(submitFinalOpFilesData({ masterFileName, data }));
  };

  const onChangeFiles = (e) => {
    setBatchSwitch((prevState) => !prevState);
    if (e.target.value === "false" && !isMergedFilesApiCalled) {
      dispatch(getMergedFiles());
      setFilesLoader(true);
    }
  };

  const handleFileChecked = (e, file, fileIndex) => {
    const { checked } = e.target;
    if (checked) {
      mergedFIlesList[fileIndex].checked = true;
      setMergedFIlesList([...mergedFIlesList]);
    } else if (!checked) {
      mergedFIlesList[fileIndex].checked = false;
      setMergedFIlesList([...mergedFIlesList]);
    }
  };

  const handleSuccessClose = () => {
    setSuccess(false);
    dispatch(clearApiStatus());
    // navigate("/output-list");
    navigate(`/${adminRoutes.outputList}`);
  };

  const handleNameChange = (event) => {
    const inputValue = event.target.value;

    // Handle empty string separately
    if (inputValue === "") {
      setMasterFileName("");
      return;
    }

    // // Check for special characters and space at the beginning
    // if (!/^[a-zA-Z0-9][a-zA-Z0-9\s]*$/.test(inputValue)) {
    //   // If special character is found, or empty string, do not update the state
    //   return;
    // }

    // Disallow space anywhere in the input and allow all other special characters
    if (/\s/.test(inputValue)) {
      return;
    }

    const allowedPattern = /^[a-zA-Z0-9\-_]*$/;
    //, - ._ only those
    if (!allowedPattern.test(inputValue)) {
      return; // Do not update state if it doesn't match the pattern
    }

    // Update the state if validation passes
    setMasterFileName(inputValue);
  };

  return (
    <div>
      <Header />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <div className="mb-10">
              <AdministratorHeader text="Merge Output Files" />
            </div>

            <Grid container className="mergeop-grid-container">
              <Grid item md={4} className="mergeop-grid1-style">
                <Box className="g1-box">
                  <Typography className="mergeop-text" variant="subtitle2">
                    Project Name
                  </Typography>

                  <Box className="mergeop-grid1-Box1">
                    {projectList?.map((project, i) => (
                      <Card key={i} className="mergeop-card1">
                        <label key={i} className="mergeop-lable">
                          <input
                            className="mergeop-input"
                            type="checkbox"
                            name="lang"
                            value={project.project_name}
                            onChange={(e) => handleProjectChecked(e, project)}
                          />
                          {project?.project_name}
                        </label>
                        <Tooltip
                          className="mergeop-tooltip"
                          title="View Batches"
                          arrow
                          placement="top"
                        >
                          <IconButton aria-label="delete">
                            <CalendarViewDayTwoToneIcon
                              onClick={(e) => getBatchesOfProject(project)}
                            />
                          </IconButton>
                        </Tooltip>
                      </Card>
                    ))}
                  </Box>
                </Box>
              </Grid>
              <Grid item md={4} className="mergeop-grid2-style">
                <Box className="g1-box">
                  <Typography
                    className="mergeop-grid2-text-style"
                    variant="subtitle2"
                  >
                    Batches
                  </Typography>
                  <Box className="mergeop-grid2-Box1">
                    <FormControl className="mergeop-form-control">
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={
                          selectedProjectId !== null
                            ? selectedProjectId
                            : "Select Project"
                        }
                        size="small"
                        onChange={handleChange}
                      >
                        {data?.map((project, index) => {
                          return (
                            <MenuItem value={index}>
                              {project?.projName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    {/* </Box> */}
                    <Button
                      className="add-btn"
                      onClick={addBatches}
                      startIcon={<AddIcon />}
                      disabled={
                        selectedProjectId !== null && selectedProjectId >= 0
                          ? false
                          : true
                      }
                    >
                      Add
                    </Button>
                  </Box>
                  <Box className="merge-container">
                    {/* <Typography>Batches</Typography> */}
                    <Switch
                      onChange={(e) => onChangeFiles(e)}
                      value={batchSwitch}
                    />
                    <Typography>Show Merged Files</Typography>
                  </Box>
                  <Box className="mergeop-grid2-Box2">
                    {/* {batchNames?.length > 0 && <Typography>Batches</Typography>} */}

                    {batchLoader && (
                      <Box>
                        <CircularProgress />
                      </Box>
                    )}

                    {batchNames?.map((batch, batchIndex) => (
                      <Card key={batch?.batch_name} className="mergeop-card2">
                        <CheckBox
                          checked={batch?.checked ? true : false}
                          id={batch?.batch_name}
                          onChange={(e) =>
                            handleBatchChecked(e, batch, batchIndex)
                          }
                          inputProps={{ "aria-label": "controlled" }}
                        />
                        <Typography className="text-style" variant="subtitle1">
                          {batch?.batch_name}
                        </Typography>
                      </Card>
                    ))}
                    {batchSwitch && <Typography>Merged Files</Typography>}

                    {filesLoader && (
                      <Box>
                        <CircularProgress />
                      </Box>
                    )}

                    {batchSwitch &&
                      mergedFIlesList?.map((file, fileIndex) => (
                        <Card key={file?.file_name} className="mergeop-card2">
                          <CheckBox
                            checked={file?.checked ? true : false}
                            id={file.file_name}
                            onChange={(e) =>
                              handleFileChecked(e, file, fileIndex)
                            }
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography
                            className="text-style"
                            variant="subtitle1"
                          >
                            {file?.file_name}
                          </Typography>
                        </Card>
                      ))}
                  </Box>
                </Box>
              </Grid>
              <Grid item md={4} className="mergeop-grid3-style">
                <Box className="g1-box">
                  <Typography className="text-style" variant="subtitle2">
                    Selected Batches
                  </Typography>
                  <div className="master-container">
                    <TextField
                      className="text-field"
                      size="small"
                      placeholder="Master File Name"
                      value={masterFileName}
                      onChange={(event) => handleNameChange(event)}
                    />
                  </div>

                  <Box className="mergeop-grid3-Box3">
                    {data?.map((x, i) => (
                      <List
                        className="mergeop-list-style"
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                      >
                        <div className="mergeop-list-item">
                          {!data[i].isFocused ? (
                            <ListItemText
                              onClick={() => {
                                handleFocus(i);
                              }}
                            >
                              {x.projName}
                            </ListItemText>
                          ) : (
                            <TextField
                              className="mergeop-editable-text"
                              size="small"
                              value={x.projName}
                              onChange={(event) =>
                                handleProjectNameChange(event, i)
                              }
                              onBlur={(event) => handleFocus(i)}
                            />
                          )}
                        </div>
                        <Collapse
                          in={data[i]?.batches?.length}
                          timeout="auto"
                          unmountOnExit
                        >
                          {data[i]?.batches?.length &&
                            x?.batches?.map((index) => (
                              <List
                                className="mergeop-collapse-list"
                                component="div"
                                disablePadding
                              >
                                <ListItemText>{index.batch_name}</ListItemText>
                              </List>
                            ))}
                        </Collapse>
                      </List>
                    ))}
                  </Box>
                </Box>
              </Grid>
              <Grid className="mergeop-submit-grid" item md={12}>
                <AdminFooter
                  isShowPrevious={false}
                  isShowSubmit={true}
                  submitLabel="Submit"
                  onHandleClick={() => submit()}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {isDuplicte && (
        <CustomizedSnackbars
          severity="error"
          state={isDuplicte}
          text={"Project Aledy Exist"}
          handleClose={() => setIsDuplidate(false)}
        />
      )}
      {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={message}
          handleClose={() => handleSuccessClose()}
        />
      )}
      {loader === true && <ProgressBar />}
      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
    </div>
  );
}

export default Index;
